export const NEW_QUOTE = 'NEW_QUOTE';
export const GET_QUOTE_BY_ID = 'GET_QUOTE_BY_ID';
